import { CustomCircularPorgress, CustomTextFieldNoForm, TabTextLabel } from '@/shared/components/ui';
import { OrdenTrabajo } from '@/shared/interfaces';
import { Grid, Typography } from '@mui/material';
// import EquiposUtilizadosOTInstall from './EquiposUtilizadosOTInstall';
// import MaterialesUtilizadosOTInstall from './MaterialesUtilizadosOTInstall';
import { gridSizeMdLg12, gridSizeMdLg6 } from '@/shared';
import { useFetchUbicacionProductosEnabled } from '@/shared/actions/erp';
import { EquiposAdicionalesParaVenta } from '@/erp/operaciones/activaciones/instalaciones/shared/components/form/EquiposAdicionalesParaVenta';
import FormaPago from '@/shared/components/ui/FormaPago/FormaPago';
import { useForm } from 'react-hook-form';
import { useEffect } from 'react';
import { MaterialesUtilizadosInstallOTTecAsig } from '@/erp/tecnico/orden-trabajo/shared/components/SaveOrdenTrabajo/equipos';

export type EquiposMaterialesViewOTInstallFormTabProps = {
  ordenTrabajo: OrdenTrabajo;
};

const EquiposMaterialesViewOTInstallFormTab: React.FC<
  EquiposMaterialesViewOTInstallFormTabProps
> = ({ ordenTrabajo }) => {
  const { 
    data: dataUbicacionProd,
    isLoading: isLoadingUbicacionProd,
  } = useFetchUbicacionProductosEnabled({
    enabled: true,
    params: {
      page_size: 1000,
      page: 1,
      // categoria_producto: CategoryProducCodeEnum.EQUIPOS,
      ubicacion: ordenTrabajo?.flota_data?.nombre,
      codigo: ordenTrabajo?.equipos_utilizados?.[0]?.codigo,
      // filterByState: false
    }
  });

  const formAuditoriaMateriales = useForm({
    
  });

  useEffect(() => {
    formAuditoriaMateriales.reset({
      ...ordenTrabajo,
      forma_pago_aux: ordenTrabajo?.forma_pago_adicionales_tecnico?.forma_pago,
      metodo_pago_mensualidad_aux: ordenTrabajo?.forma_pago_adicionales_tecnico?.metodo_pago_mensualidad,
      valor_instalacion_total_aux: ordenTrabajo?.forma_pago_adicionales_tecnico?.valor_instalacion_total,
      valor_instalacion_aux: ordenTrabajo?.forma_pago_adicionales_tecnico?.valor_instalacion,
      valor_instalacion_iva_aux: ordenTrabajo?.forma_pago_adicionales_tecnico?.valor_instalacion_iva,
      numero_cuenta_aux: ordenTrabajo?.forma_pago_adicionales_tecnico?.numero_cuenta,
      tipo_cuenta_bancaria_aux: ordenTrabajo?.forma_pago_adicionales_tecnico?.tipo_cuenta_bancaria,
      numero_tarjeta_aux: ordenTrabajo?.forma_pago_adicionales_tecnico?.numero_tarjeta,
      entidad_financiera_aux: ordenTrabajo?.forma_pago_adicionales_tecnico?.entidad_financiera,
      codigo_forma_pago_aux: ordenTrabajo?.forma_pago_adicionales_tecnico?.codigo_forma_pago,
      tipo_contrato_aux: ordenTrabajo?.forma_pago_adicionales_tecnico?.tipo_contrato,
      tarjeta_aux: ordenTrabajo?.forma_pago_adicionales_tecnico?.tarjeta,
    })
    console.log({"vamosviendoquepasa":formAuditoriaMateriales.getValues()})
  }, []);
  return (
    <>

      {/* <Grid {...gridSizeMdLg12} container item>
        <Typography variant="h6">Equipos de Instalación</Typography>
      </Grid> */}
      {
        isLoadingUbicacionProd ? (
          <CustomCircularPorgress />
        ) : (
          <CustomTextFieldNoForm
            label="ONT UTILIZADA"
            value={`${dataUbicacionProd?.data?.data?.[0]?.producto_data?.descripcion} - ${ordenTrabajo?.equipos_utilizados?.[0]?.series?.[0]}`}
            size={gridSizeMdLg12}
            disabled
          />
        )
      }
      {/* <TabTextLabel text="EQUIPOS UTILIZADOS" pt="48px" />
      <Grid item xs={12}>
        <EquiposUtilizadosOTInstall ordenTrabajo={ordenTrabajo} />
      </Grid> */}

      <TabTextLabel text="MATERIALES UTILIZADOS" pt="42px" />
      <Grid item xs={12}>
        {/* <MaterialesUtilizadosOTInstall ordenTrabajo={ordenTrabajo} /> */}
        
        {
          formAuditoriaMateriales?.getValues()?.materiales_utilizados && formAuditoriaMateriales?.getValues()?.materiales_utilizados?.length > 0?
          <>
            <MaterialesUtilizadosInstallOTTecAsig form={formAuditoriaMateriales} 
            ubicacion={ordenTrabajo?.flota_data?.ubicacion!} showToActivaciones onlyShow/>
          </>
          :
          <MaterialesUtilizadosInstallOTTecAsig form={formAuditoriaMateriales} 
          ubicacion={ordenTrabajo?.flota_data?.ubicacion!}/>
        }
      </Grid>
      

      <Grid {...gridSizeMdLg12} container item gap={1}>
        <Grid {...gridSizeMdLg6} alignContent={"center"}>
          <Typography variant="h6">Equipos Adicionales para la Venta</Typography>
        </Grid>
      </Grid>

      <EquiposAdicionalesParaVenta form={formAuditoriaMateriales} onlyShow={true}/>
      <FormaPago form={formAuditoriaMateriales}/>
    </>
  );
};

export default EquiposMaterialesViewOTInstallFormTab;
